var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"align":"center"}},[_c('span',{style:(_vm.style)},[_c('i',{class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }